export default [
  {
    name: 'users',
    path: '/admin/users',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Usuários',
      icon: 'dvr',
      label: 'Usuários',
      roles: ['Admin']
    }
  }
]
